export default function AssistanceSummaryValidation(values: any) {
  let errors: any = {};

  if (!values.vehicle_id) {
    errors.vehicle_id = "Debes seleccionar un vehículo";
  }

  // console.log(errors);
  return errors;
}
